import * as React from 'react';

const BankIcon = ({ className , color ="#333333" , size ="24px" , style  })=>/*#__PURE__*/ React.createElement("svg", {
        "data-testid": "svg-bank",
        className: className,
        style: style,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2.84827L20 7.4197V11H4V7.4197L12 2.84827ZM6 8.58034V9.00002H18V8.58034L12 5.15177L6 8.58034ZM6 17V12H8V17H6ZM11 17V12H13V17H11ZM16 17V12H18V17H16ZM4 20V18H20V20H4Z",
        fill: color
    }));

export { BankIcon };
